export const NEED_TO_UPDATE_MODAL_IS_SEEN_BY_USER = 'userWithStatusNeedToUpdateModalShown';
